import { Text, Textarea, VStack } from '@chakra-ui/react'
import React from 'react'

interface ModalTextareaProps {
  label?: string
  name: string
  placeholder?: string
  isInvalid?: boolean
  value: string
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void
  required?: boolean
  rows?: number
  minH?: string
  resize?: 'none' | 'vertical' | 'horizontal' | 'both'
  maxLength?: number
}

const ModalTextarea: React.FC<ModalTextareaProps> = ({
  label,
  name,
  placeholder,
  isInvalid,
  value,
  onChange,
  required,
  rows,
  minH,
  resize = 'vertical',
  maxLength,
}) => {
  return (
    <VStack align="left" spacing="4px" width="100%">
      {label && (
        <Text textStyle="l-xs" color={required ? 'solid.700' : 'solid.500'} fontWeight={required ? '600' : undefined}>
          {label}
          {required && <Text as="span" color="primary.100"> *</Text>}
        </Text>
      )}
      <Textarea
        name={name}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        isInvalid={isInvalid}
        bg={required ? 'primary.0' : undefined}
        borderColor={required ? 'primary.50' : undefined}
        _focus={required ? { borderColor: 'primary.100', bg: 'white' } : undefined}
        rows={rows}
        minH={minH}
        resize={resize}
        maxLength={maxLength}
      />
    </VStack>
  )
}

export default ModalTextarea
